import { WeaTools } from 'ecCom'
//获取导入表单
export const getImportForm = (params) => {
  return WeaTools.callApi(`/api/hrm/import/resource/getImportForm`, 'GET', params);
}
//导入文件提交
export const saveImport = (params) => {
  return WeaTools.callApi(`/api/hrm/import/resource/saveImport`, 'POST', params);
}
//获取导入结果回调数据
export const getImportProcessLog = (params) => {
  return WeaTools.callApi(`/api/hrm/importlog/getImportProcessLog`, 'GET', params);
}
//获取导入结果
export const getImportResult = (params) => {
  return WeaTools.callApi(`/api/hrm/importlog/getImportResult`, 'GET', params);
}
//历史导入信息查询
export const getImportHistory = (params) => {
  return WeaTools.callApi(`/api/hrm/importlog/getImportHistory`, 'GET', params);
}
//导入日志
export const getImportLogDetail = (params) => {
  return WeaTools.callApi(`/api/hrm/importlog/getImportColResultLog`, 'GET', params);
}
//导入日志 - 高级搜索
export const getImportLogSearchCondition = (params) => {
  return WeaTools.callApi(`/api/hrm/importlog/getHistorySearchCondition`, 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4backstage/hrmengine/apis/importresource.js